import { createPortal } from "react-dom";

export default function ModaRedirect({
  isOpen,
  onClose,
  children,
  noOpacity = false,
}) {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[999999] flex items-center justify-center overflow-y-auto">
      <div className="fixed inset-0 transition-opacity duration-300">
        <div
          className={`absolute inset-0 bg-gray-800 ${
            noOpacity ? "opacity-0" : "opacity-85"
          }`}
          onClick={onClose}
        />
      </div>

      <div className="relative z-10 overflow-hidden transform transition-all duration-300 min-h-max min-w-[35%] max-w-5xl">
        {children}
      </div>
    </div>,
    document.body
  );
}
